import { toast } from "react-toastify"

export const responsesTypes = (error, warning, message, messageColor = "success") => {
  if (error && error !== "") toast.error(error)
  if (warning && warning !== "") toast.warning(warning)
  if (message && message !== "" && messageColor === "success") toast.success(message)
  if (message && message !== "" && messageColor === "info") toast.info(message)
  if (message && message !== "" && messageColor === "error") toast.error(message)
}
